<template>
  <div class="checkProfessional">
    <div class="checkProfessional__content">
      <h1 class="checkProfessional__title">Confirme se o nome do profissional está correto</h1>
      <p class="checkProfessional__subtitle">
        Caso o nome não seja igual ao do pedido médico, altere os dados do profissional.
      </p>

      <VInputWithIcon
        disabled
        label="Nome do profissional"
        :prefix="false"
        :suffix="true"
        :disabledIcon="true"
        :value="professionalData.name"
        ><PadlockSvg
      /></VInputWithIcon>
    </div>

    <div class="checkProfessional__btnsgroup">
      <VButton
        class="checkProfessional__btn"
        text="Confirmar nome do profissional"
        variant="primary"
        @click.native="updatedProfessional()"
      />
      <VButton
        text="Alterar dados do profissional"
        variant="tertiary"
        @click.native="editProfessional()"
      />
    </div>
  </div>
</template>

<script>
import VInputWithIcon from '@/components/commons/VInputWithIcon.vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  name: 'checkProfessionalIdentification',
  components: {
    VInputWithIcon,
  },
  mixins: [dataLayersMixin],
  computed: {
    ...mapState({
      professionalData: ({ professionalIdentification }) =>
        professionalIdentification.professionalData,
    }),
    ...mapGetters({
      getMedicalOrders: 'getMedicalOrders',
    }),
  },
  methods: {
    ...mapActions(['updateMedicalOrders']),
    editProfessional() {
      return this.goNextStep('professional_identification');
    },
    async updatedProfessional() {
      const payload = {
        uuid: this.getMedicalOrders[0].uuid,
        mdmIdRequestingDoctor: this.professionalData.mdmProfessionalId,
        exams: [...this.getMedicalOrders[0].exams],
      };
      await this.updateMedicalOrders(payload);
      return this.goNextStep('questions_step');
    },
  },
  created() {
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Cadastro de profissional encontrado',
    });
  },
};
</script>

<style lang="scss">
.checkProfessional {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__title {
    color: #292929;
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 8px;
  }

  &__subtitle {
    color: #363636;
    font-size: 16px;
    margin-bottom: 32px;
  }

  &__btnsgroup {
    width: 100%;
  }

  &__btn {
    width: 100%;
    margin-bottom: 8px;
  }
}
</style>
